
import { Card } from "@/components/ui/card";
import { ResultsHeader } from "./ResultsHeader";
import { ResultsContent } from "./ResultsContent";
import { ResultsActions } from "./ResultsActions";
import { Answer, OrganizationDetails } from "@/types/assessment";

interface ResultsProps {
  organizationDetails: OrganizationDetails;
  maturityLevel: string;
  overallScore: number;
  description: string;
  dimensionScores: Record<string, number>;
  answers: Answer[];
  onStartNew: () => void;
  onSave?: () => void;
  isSaving?: boolean;
  savedAssessmentId?: string | null;
  assessmentId: string;
  isViewMode?: boolean;
}

export const Results = ({ 
  organizationDetails,
  maturityLevel,
  overallScore,
  description,
  dimensionScores,
  onStartNew,
  onSave,
  isSaving,
  savedAssessmentId,
  assessmentId,
  isViewMode = false,
}: ResultsProps) => {
  return (
    <Card className="w-full max-w-5xl mx-auto">
      <div className="p-6 space-y-8" data-organization-name={organizationDetails.name}>
        <ResultsHeader 
          organizationName={organizationDetails.name}
          assessmentDate={organizationDetails.assessmentDate}
          industry={organizationDetails.industry}
          organizationSize={organizationDetails.size}
          organizationType={organizationDetails.organizationType}
          country={organizationDetails.country}
          assessorName={organizationDetails.assessorName}
          assessorRole={organizationDetails.assessorRole}
          assessorEmail={organizationDetails.assessorEmail}
        />

        <ResultsContent 
          overallScore={overallScore}
          description={description}
          dimensionScores={dimensionScores}
          maturityLevel={maturityLevel}
          industry={organizationDetails.industry}
          organizationSize={organizationDetails.size}
          assessmentId={assessmentId}
          organizationDetails={organizationDetails}
        />

        <ResultsActions 
          onStartNew={onStartNew}
          onSave={onSave}
          isSaving={isSaving}
          savedAssessmentId={savedAssessmentId}
          results={{
            organizationDetails,
            maturityLevel,
            overallScore,
            description,
            dimensionScores
          }}
          isViewMode={isViewMode}
        />
      </div>
    </Card>
  );
};
